import { render, staticRenderFns } from "./jiedaiZhuyuan.vue?vue&type=template&id=bd3ec52e&scoped=true&"
import script from "./jiedaiZhuyuan.vue?vue&type=script&lang=js&"
export * from "./jiedaiZhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./jiedaiZhuyuan.vue?vue&type=style&index=0&id=bd3ec52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3ec52e",
  null
  
)

export default component.exports